/**
 * Whether an Escape keydown is an inner control's to handle, not the overlay's.
 *
 * The full-screen previews close on Escape from a window listener (and, for
 * the one stacked over Edit Mapping, from Radix's top dismissable layer). The
 * sheet viewer inside them has a search box that ALSO closes on Escape and does
 * not stop the event, so one press closed the search and the whole overlay with
 * it — the reviewer lost the file they were inspecting (Greptile, #34218).
 *
 * The rule: while the reader is typing in a field, Escape belongs to that
 * field. A second press, once the field has let go of focus, closes the
 * overlay. `defaultPrevented` is honoured too, for any control that does say
 * it consumed the key.
 */
export const escapeBelongsToInput = (event: KeyboardEvent): boolean => {
  if (event.defaultPrevented) return true
  const target = event.target
  if (!(target instanceof HTMLElement)) return false
  return target.closest('input, textarea, select, [contenteditable="true"]') !== null
}
